import { SagaIterator } from 'redux-saga';
import { fork, put, take } from 'redux-saga/effects';
import config from '@/server/config';
import request from '@/server/request';

// 定义常量
export const types = {
    CATEGORY_APP_CONFIRM: 'user/ui/CATEGORY_APP_CONFIRM',
    CATEGORY_APP_HIDE: 'user/ui/CATEGORY_APP_HIDE',
    CATEGORY_APP_SELECT: 'user/ui/CATEGORY_APP_SELECT',
    CATEGORY_APP_SHOW: 'user/ui/CATEGORY_APP_SHOW',
    CATEGORY_APP_TAB: 'user/ui/CATEGORY_APP_TAB',
    GET_CATEGORY_APP_START: 'user/ui/GET_CATEGORY_APP_START',
    GET_CATEGORY_APP_SUCCESS: 'user/ui/GET_CATEGORY_APP_SUCCESS'
}

let bindConfirmAction: any;
let bindHideAction: any;

// 定义地址action接口
export interface ICategoryAppAction {
    type: string;
    showData?: {
        onConfirm?(r: any): void;
        onHide?(): void;
        init?: any;
    }
    selectData?: {
        index: number;
        k: number;
    };
    tabData?: {
        index: number;
    };
    payload?: any;
}
// 定义地址状态接口
export interface ICategoryAppStoreState {
    lvList1: any[];
    lvList2: any[];
    lvList3: any[];
    lvList4: any[];
    lvIndex2: number,
    lvIndex3: number,
    lvIndex1: number,
    lvIndex4: number,
    tabIndex: number,
    visible: boolean;
}

// 定义各方法，以供组件内部调用
/**
 * [获取数据]
 * @return action类型 
 */
export const getData = (): ICategoryAppAction => {
    return {
        type: types.GET_CATEGORY_APP_START
    }
}
// 隐藏面板
export const hideAction = () => {
    return {
        type: types.CATEGORY_APP_HIDE
    }
}

//  切换
export const tabAction = (index: number) => {
    return {
        tabData: {
            index
        },
        type: types.CATEGORY_APP_TAB
    }
}

// 选择某一项
export const selectItem = (index: number, k: number) => {
    return {
        selectData: {
            index, k
        },
        type: types.CATEGORY_APP_SELECT
    }
}

/**
 * [导出reducer] 使用export default导出，Ducks模式规则
 * @param state 组件状态
 * @param action 组件本次提供的action
 * @return 组件状态
 */
const initialState: ICategoryAppStoreState = {
    lvList1: [],
    lvList2: [],
    lvList3: [],
    lvList4: [],
    lvIndex2: -1,
    lvIndex3: -1,
    lvIndex1: -1,
    lvIndex4: -1,
    tabIndex: 0,
    visible: false
};
export default (state: ICategoryAppStoreState = initialState, action: ICategoryAppAction): ICategoryAppStoreState => {
    switch(action.type) {
        case types.CATEGORY_APP_CONFIRM:
            return {
                ...state,
                visible: false
            }
        case types.CATEGORY_APP_SHOW:
            // 绑定确认处理函数
            if(action.showData && action.showData.onConfirm) {
                bindConfirmAction = action.showData.onConfirm;
            } else {
                bindConfirmAction = null;
            }
            // 绑定取消处理函数
            if(action.showData && action.showData.onHide) {
                bindHideAction = action.showData.onHide;
            } else {
                bindHideAction = null;
            }
            const initData = action.showData && action.showData.init ? action.showData.init : {};
            if(initData.lv1 && initData.lv1.id) {
                let [templvIndex1, templvIndex2, templvIndex3, templvIndex4] = [-1, -1, -1, -1];
                let tabIndex = -1;
                let list2: any[] = [];
                let list3: any[] = [];
                let list4: any[] = [];
                state.lvList1.map((v: any, k: number) => {
                    if(v.id === initData.lv1.id) {
                        templvIndex1 = k;
                        list2 = v.children || [];
                        tabIndex = 0;
                        list2.map((v1: any, k1: number) => {
                            if(v1.id === initData.lv2.id) {
                                templvIndex2 = k1;
                                list3 = v1.children || [];
                                tabIndex = 1;
                                list3.map((v2: any, k2: number) => {
                                    if(v2.id === initData.lv3.id) {
                                        templvIndex3 = k2;
                                        list4 = v2.children || [];
                                        tabIndex = 2;
                                        list4.map((v3: any, k3: number) => {
                                            if(v3.id === initData.lv4.id) {
                                                templvIndex4 = k3;
                                                tabIndex = 3;
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
                return {
                    ...state,
                    lvIndex2: templvIndex2,
                    lvIndex3: templvIndex3,
                    lvIndex1: templvIndex1,
                    lvIndex4: templvIndex4,
                    lvList2: list2,
                    lvList3: list3,
                    lvList4: list4,
                    tabIndex,
                    visible: true
                }
            } else {
                return {
                    ...state,
                    lvIndex2: -1,
                    lvIndex3: -1,
                    lvIndex1: -1,
                    lvIndex4: -1,
                    tabIndex: 0,
                    lvList2: [],
                    lvList3: [],
                    lvList4: [],
                    visible: true,
                }
            }
        case types.CATEGORY_APP_HIDE:
            if(bindHideAction) {
                bindHideAction();
            }
            return {
                ...state,
                visible: false
            }
        case types.CATEGORY_APP_SELECT:
            if (action.selectData) {
                if (action.selectData.index === 0) { 
                    const temp = {
                        ...state,
                        lvIndex1: action.selectData.k,
                        lvList2: state.lvList1[action.selectData.k].children,
                        lvList3: [],
                        lvList4: [],
                        tabIndex: 1
                    };
                    if (state.lvList1[action.selectData.k].children.length === 0) { 
                        temp.lvList2 = [];
                        temp.tabIndex = 0;
                        temp.visible = false;
                        if (bindConfirmAction) { 
                            bindConfirmAction({
                                lv1: state.lvList1[action.selectData.k],
                                lv2: {},
                                lv3: {},
                                lv4: {}
                            });
                        }
                    }
                    return temp;
                } else if (action.selectData.index === 1) {
                    const temp = {
                        ...state,
                        lvIndex2: action.selectData.k,
                        lvList3: state.lvList2[action.selectData.k].children,
                        lvList4: [],
                        tabIndex: 2
                    }
                    if (state.lvList2[action.selectData.k].children.length === 0) { 
                        temp.lvList3 = [];
                        temp.tabIndex = 1;
                        temp.visible = false;
                        if (bindConfirmAction) { 
                            bindConfirmAction({
                                lv1: state.lvList1[state.lvIndex1],
                                lv2: state.lvList2[action.selectData.k],
                                lv3: {},
                                lv4: {}
                            });
                        }
                    }
                    return temp;
                } else if (action.selectData.index === 2) {
                    const temp = {
                        ...state,
                        lvIndex3: action.selectData.k,
                        lvList4: state.lvList3[action.selectData.k].children,
                        tabIndex: 3
                    }
                    if (state.lvList3[action.selectData.k].children.length === 0) { 
                        temp.lvList4 = [];
                        temp.tabIndex = 2;
                        temp.visible = false;
                        if (bindConfirmAction) { 
                            bindConfirmAction({
                                lv1: state.lvList1[state.lvIndex1],
                                lv2: state.lvList2[state.lvIndex2],
                                lv3: state.lvList3[action.selectData.k],
                                lv4: {}
                            });
                        }
                    }
                    return temp;
                } else {
                    if(bindConfirmAction) {
                        bindConfirmAction({
                            lv1: state.lvList1[state.lvIndex1],
                            lv2: state.lvList2[state.lvIndex2],
                            lv3: state.lvList3[state.lvIndex3],
                            lv4: state.lvList4[action.selectData.k],
                        });
                    }
                    return {
                        ...state,
                        lvIndex4: action.selectData.k,
                        visible: false
                    }
                }
            } else {
                return state;
            }
        case types.CATEGORY_APP_TAB:
            if(action.tabData) {
                if (action.tabData.index === 0) {
                    return {
                        ...state,
                        lvIndex1: -1,
                        lvIndex2: -1,
                        lvIndex3: -1,
                        lvIndex4: -1,
                        tabIndex: action.tabData.index
                    }
                } else if (action.tabData.index === 1) {
                    return {
                        ...state,
                        lvIndex2: -1,
                        lvIndex3: -1,
                        lvIndex4: -1,
                        tabIndex: action.tabData.index
                    }
                } else if (action.tabData.index === 2) {
                    return {
                        ...state,
                        lvIndex3: -1,
                        lvIndex4: -1,
                        tabIndex: action.tabData.index
                    }
                } else { 
                    return {
                        ...state,
                        lvIndex4: -1,
                        tabIndex: action.tabData.index
                    }
                }
            } else {
                return state;
            }
        case types.GET_CATEGORY_APP_SUCCESS:
            const r = action.payload.data;
            if (r.error_code === 0 && r.data) {
                return {
                    ...state,
                    lvList1: r.data
                }
            } else {
                return state;
            }
        default:
            return state;
    }
}

// 定义saga
/**
 * 本页面使用，获取数据异步操作处理函数
 * @param action 组件提供action
 */
function* getListDataAsync( action: ICategoryAppAction ): any {
    const r = yield request({
        url: `${config.ULKAPI}api/web/index.php?r=second/search/application-class`,
        data: {
            filter: 0
        }
    });
    yield put({ type: types.GET_CATEGORY_APP_SUCCESS, payload: {
        data: r,
    } });
}

// 利用takeEvery检测未来可能会发生的行为，并且执行相应的操作
export function* watchAppCategoryDataAsync(): SagaIterator {
    // 写法1（可以连续接收到action）
    // yield takeEvery( types.RECEIVE_START, getListDataAsync );

    // 写法2（时间间隔过短无法连续接收到action，会有遗漏，可使用异步fork避免）
    while(true) {
        const action = yield take(types.GET_CATEGORY_APP_START);
        console.log('start load app category');
        yield fork(getListDataAsync, action);
    }
}

